/**
 * The `BiteAttempt.id` contract: `"{sessionId}:{slideIdx}:{slideEndTs}"`.
 *
 * Not an opaque key — the practice modal splits it apart to address the
 * snapshot row for THAT attempt, so the format is a contract across three
 * files. One place to build, one to parse.
 *
 * A missing `slideEndTs` yields an EMPTY last segment on purpose: consumers
 * read that as "not pinned" and fall back to the newest attempt. Inventing a
 * plausible number instead silently addresses a row that does not exist.
 */

export type ParsedAttemptId = {
  sessionId: string;
  slideIdx: string;
  /** undefined when the attempt is not pinned to one snapshot row. */
  slideEndTs?: string;
};

export function buildAttemptId(
  sessionId: string,
  slideIdx: number | string,
  slideEndTs?: number | string | null,
): string {
  return `${sessionId}:${slideIdx}:${slideEndTs ?? ""}`;
}

export function parseAttemptId(attemptId: string | undefined): ParsedAttemptId {
  const [sessionId = "", slideIdx = "", slideEndTs = ""] = (
    attemptId ?? ""
  ).split(":");
  return { sessionId, slideIdx, slideEndTs: slideEndTs || undefined };
}
